import React, { useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import SoftBox from "components/SoftBox";
import { Button } from "@mui/material";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import toast from "react-hot-toast";
import GhlMediaGallery from "components/GhlMediaGallery";
import { FaImages } from "react-icons/fa";
import PrimaryButton from "../../../components/PrimaryButton";
import "./accountDetailTabs.css";

function Team({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [oldImageId, setOldImageId] = useState(null);
  const [agency] = useAgencyInfo();

  const [currentFormData, setCurrentFormData] = useState({
    image: "",
    image_id: "",
    name: "",
    designation: "",
    description: "",
  });

  const [ghlGalleryOpen, setGhlGalleryOpen] = useState(false);

  const openGhlGallery = () => setGhlGalleryOpen(true);

  const handleGhlImageSelect = (pick) => {
    if (!pick?.url) return;
    setCurrentFormData((prev) => ({ ...prev, image: pick?.url, image_id: pick?._id }));
    setOldImageId(currentFormData.image_id ? currentFormData.image_id : null);
    toast.success("Image selected.");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingButton(true);

    const newTeam = {
      image: currentFormData.image,
      name: currentFormData.name,
      designation: currentFormData.designation,
      description: currentFormData.description,
      image_id: currentFormData.image_id,
    };

    let updatedTeam;
    if (isEditing) {
      updatedTeam = formData.team.map((item, index) =>
        index === editingIndex ? newTeam : item
      );
    } else {
      updatedTeam = Array.isArray(formData.team)
        ? [...formData.team, newTeam]
        : [newTeam];
    }

    const payload = {
      _id: formData.id,
      team: updatedTeam,
      ...(oldImageId && { old_image_id: oldImageId }),
    };

    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      handleRefresh();
      resetForm();
      setLoadingButton(false);
      toast.success("Data updated Successfully");
      setOldImageId(null);
    } else {
      toast.error("Error updating Data");
      setLoadingButton(false);
      setOldImageId(null);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setSuccess("");
  };

  const handleEdit = (team, index) => {
    setCurrentFormData(team);
    setIsEditing(true);
    setEditingIndex(index);
  };

  const deleteTeam = async (team) => {
    const payload = {
      _id: formData.id,
      team: formData.team.filter((item) => item !== team),
      ...(team?.image_id && { old_image_id: team?.image_id }),
    };
    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      handleRefresh();
      toast.success("Delete Successfully");
    } else {
      toast.error("Error deleting");
    }
  };

  const resetForm = () => {
    setCurrentFormData({
      image: "",
      image_id: "",
      name: "",
      designation: "",
      description: "",
    });
    setIsEditing(false);
    setEditingIndex(null);
  };

  return (
    <div className="sd-account-detail-tab">
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div
            style={{
              width: "25%",
              padding: "10px 10px 0px 10px",
              border: "1px solid #ccc",
            }}
          >
            <div>
              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Image</label>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "6px" }}>
                  <button
                    type="button"
                    onClick={openGhlGallery}
                    title="Choose from Media"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "8px",
                      background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                      color: "white",
                      border: "none",
                      padding: "10px 18px",
                      borderRadius: "10px",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      boxShadow: "0 2px 6px rgba(25, 118, 210, 0.35)",
                    }}
                  >
                    <FaImages size={16} />
                    {currentFormData.image ? "Change Photo" : "Select from Media"}
                  </button>
                  {currentFormData.image && (
                    <img
                      src={currentFormData.image}
                      alt="Team"
                      width={56}
                      height={56}
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "50%",
                        border: "1px solid #e2e8f0",
                      }}
                    />
                  )}
                </div>
              </SoftBox>

              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Full Name</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  value={currentFormData.name}
                  placeholder="Full Name"
                  name="name"
                />
              </SoftBox>

              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Designation</label>
                <input
                  className="form-control-agust"
                  onChange={handleChange}
                  value={currentFormData.designation}
                  placeholder="Designation"
                  name="designation"
                />
              </SoftBox>

              <SoftBox style={{ margin: "10px 0px " }}>
                <label className="text-black">Description</label>
                <textarea
                  className="form-control-agust"
                  onChange={handleChange}
                  value={currentFormData.description}
                  placeholder="Description"
                  name="description"
                />
              </SoftBox>
            </div>
            <div style={{ margin: "10px 0px", textAlign: "right" }}>
              <PrimaryButton
                disabled={loadingButton}
                type="submit"
                showPlus={!isEditing && !loadingButton}
              >
                {loadingButton
                  ? "loading..."
                  : isEditing
                    ? "Update Team"
                    : "Add Team"}
              </PrimaryButton>
            </div>
          </div>

          <div style={{ width: "75%", paddingLeft: "10px" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {formData.team &&
                formData.team.map((team, index) => (
                  <div
                    key={index}
                    style={{
                      width: "25%",
                      padding: "10px",
                      textAlign: "center",
                      border: "1px solid #ccc",
                    }}
                  >
                    <img
                      src={
                        team?.image ||
                        "https://www.w3schools.com/howto/img_avatar.png"
                      }
                      className="img-fluid rounded-top"
                      alt=""
                      width={100}
                      height={100}
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "50%",
                      }}
                    />
                    <p>
                      <b>{team.name}</b>
                    </p>
                    <b>{team.designation}</b>
                    <div>
                      <small>{team.description}</small>
                    </div>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: "10px",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="white"
                        onClick={() => handleEdit(team, index)}
                      >
                        <img src={editIcon} width={20} alt="edit" />
                      </Button>
                      <Button
                        variant="contained"
                        color="white"
                        style={{ background: "#e44d36", color: "#fff" }}
                        onClick={() => deleteTeam(team)}
                      >
                        <img src={deleteIcon} width={20} alt="delete" />
                      </Button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </form>

      <GhlMediaGallery
        open={ghlGalleryOpen}
        onClose={() => setGhlGalleryOpen(false)}
        onSelect={handleGhlImageSelect}
        title="Select Team Photo"
        enableCrop
        cropAspectRatio={1}
      />
    </div>
  );
}

export default Team;
